import styled from 'styled-components/macro';

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  border-radius: 8px;
  border: 1px solid #ced5de;
  padding: 12px;
`;

export const FieldWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const PhoneRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const CountryCode = styled.span`
  flex-shrink: 0;
  color: #1f2939;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const PhoneField = styled.div`
  flex: 1;
  min-width: 0;
`;

export const StyledInput = styled.input`
  width: 100%;
  color: #1f2939;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  border: none;
  outline: none;

  ::placeholder {
    color: #697180;
  }
`;

export const ErrorMessage = styled.span`
  position: absolute;
  white-space: nowrap;
  top: 30px;
  left: 12px;
  font-size: 12px;
  z-index: 100000;
  color: rgb(235, 77, 64);
`;
